import WebViewApi from '@/api/webview'

const defaultForm = {
  message: '',
  fb_preset_id: 0,
  pages: [],
  reply_message: '',
  schedule_type: 'now',
  schedule_time: [''],
  template_id: '',
  type: 'message',
}
export default {
  namespaced: true,
  state: {
    form: defaultForm,
    templates: [],
    templatesFetched: {},
  },
  getters: {
    form: (state: any) => state.form,
    templates: (state: any) => state.templates ?? [],
  },
  mutations: {
    SET_FORM(state: any, form: any) {
      state.form = { ...state.form, ...form }
    },
    SET_TEMPLATES(state: any, templates: any) {
      state.templates = templates
    },
    SET_TEMPLATE_FETCHED(state: any, payload: any) {
      state.templatesFetched[payload.page] = payload?.value ?? true
    },
  },
  actions: {
    async GET_TEMPLATES(context: any) {
      const pageId = context.rootGetters['pages/currentPageId']
      if (context.state.templatesFetched[pageId]) return
      await WebViewApi.templatesList(pageId).then((data: any) => {
        context.commit('SET_TEMPLATES', data)
        context.commit('SET_TEMPLATE_FETCHED', { page: pageId, value: true })
      }).catch(e => {
        throw e
      })
    },
  },
}
